import React from 'react'
import { CustomCard } from '../../../../components'
import { verde, vermelho } from '../../../../assets/js/colors'

export default function CanhotoCards({ resumo }) {
  const totalEntregas = resumo ? resumo.qte_entregas : 0
  const totalComCanhoto = resumo ? resumo.qte_com_canhoto : 0
  const totalSemCanhoto = resumo ? resumo.qte_sem_canhoto : 0

  return (
    <div className="p-grid" style={{ marginTop: 10, marginBottom: 10 }}>
      <div className="p-col-4">
        <CustomCard
          title="Total de Entregas"
          subTitle="Quantidade total de entregas"
          valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
        >
          {totalEntregas}
        </CustomCard>
      </div>
      <div className="p-col-4">
        <CustomCard
          title="Entregas com Canhoto"
          subTitle="Quantidade de entregas com canhoto"
          valueStyle={{ color: verde, fontSize: '1.3rem', fontWeight: 600 }}
        >
          {totalComCanhoto}
        </CustomCard>
      </div>
      <div className="p-col-4">
        <CustomCard
          title="Entregas sem Canhoto"
          subTitle="Quantidade de entregas sem canhoto"
          valueStyle={{ color: vermelho, fontSize: '1.3rem', fontWeight: 600 }}
        >
          {totalSemCanhoto}
        </CustomCard>
      </div>
    </div>
  )
}
